import React, { PropsWithChildren } from "react"
import "./ErrorMsg.scss"

const ErrorMsg: React.FC<PropsWithChildren<{slowFadeIn?: boolean}>> = ({ children, slowFadeIn }) => {
  const className = [
    "neo__raffleErrorMsg",
    slowFadeIn ? "neo__raffleErrorMsg--slowFadeIn" : ""
  ].join(" ")

  return <div className={className} data-testid="raffle-error-msg"><div>{children}</div></div>
}

export default ErrorMsg
